export enum fetchListItems {
    chainAutocomplete = "chain_autocomplete",
    tokenAutocomplete = "token_autocomplete",
    nftAutocomplete = "nft_autocomplete",
    socialMediaFeedback = "socialMediaFeedback",
    csvUpload = "csv_upload",
    filtration = "filtration_api",
    getAudiences = "get_audiences",
    saveAudience = "save_audience",
    exportAudience = "export_audience",
    getUser = "get_user",
    updateUser = "update_user",
    addRecentSelection = "add_recent_selection",
}